import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Bot } from "../../../../models/bot";
import { Event } from "../../../../models/event";
import { EventType } from "../../../../models/event-type";
import { Role } from "../../../../models/role";
import { BotControllerService } from "../../../../services/role-controller/bot-controller.service";
import { Store } from "../../../../services/store.service";
import {TranslatedBaseError} from "../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import { ServiceRoleComponent } from "../../../../components/pages/roles/components/service/service-role.component";

@Component({
  selector: "app-edit-bot",
  templateUrl: "./edit-bot.component.html",
  styleUrls: ["./edit-bot.component.scss"],
})
export class EditBotComponent extends TranslatedBaseError implements OnInit {

    public role: Role;
    public serviceId: string;
    @Input() public bot: Bot = new Bot();
    @Output() public modalClosedEvent = new EventEmitter();
    @Output() public modalAddedEvent = new EventEmitter();
    @Input() public activeTab: string = "general";

    public mappingReady: boolean = false;

    @ViewChild(ServiceRoleComponent) public serviceRoleComponent: ServiceRoleComponent;

    constructor(private router: Router,
                private route: ActivatedRoute,
                public store: Store,
                private botController: BotControllerService,
                private changeDetectorRef: ChangeDetectorRef,
                toastr: ToastrService, public translateService: TranslateService) {
        super(toastr, translateService);
    }

    public ngOnInit() {
        this.getParams();
    }

    public getParams() {
        this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
        });
    }

    public cancel() {
        this.modalClosedEvent.emit(new Event(null, EventType.Cancel));
    }

    public added() {
        this.modalAddedEvent.emit(new Event(null, EventType.Add));
    }

    public closeLayer() {
        this.router.navigate([`/services/${this.serviceId}/bots`]);
    }

    public notifyTabChange(tab) {
        this.activeTab = tab;
    }

    public updateRole() {
        const successCb = (data: any) => {
            this.responseSuccessful("Bot saved!");
            this.modalAddedEvent.emit(new Event(null, EventType.Add));
        };
        const errorCb = (error: any) => {
            this.ngOnInit();
            return this.showErrorMessageWithTitle("Error during save/update of bot!", error);
        };
        return this.botController.saveBot(this.bot).subscribe(successCb, errorCb);
    }

    /**
     * Save bot silently without closing the drawer.
     * Used when auto-saving from mapping changes (API selection, field mappings, etc.)
     */
    public saveBotSilently() {
        const successCb = (data: any) => {
            this.responseSuccessful("Bot saved!");
        };
        const errorCb = (error: any) => {
            return this.showErrorMessageWithTitle("Error during save/update of bot!", error);
        };
        return this.botController.saveBot(this.bot).subscribe(successCb, errorCb);
    }

    public onMappingReady(event): void {
        this.mappingReady = event;
        this.changeDetectorRef.detectChanges();
        this.serviceRoleComponent.togglePanel(true);
    }

    public save(): void {
        if (this.activeTab === "general") {
            // For general tab, just emit the event (role-bot-manage handles its own save)
            this.added();
        } else if (this.activeTab === "bot-service") {
            // For bot-service tab, trigger the save
            this.updateRole();
        }
    }

    public updateMappingLines(): void {
        if (this.serviceRoleComponent) {
            this.serviceRoleComponent.checkLinesVisibility();
        }
    }

}
